import * as React from "react";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import Spinner from "../common/spinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import SectionLoadingError from "../common/SectionLoadingError";
import * as queryString from 'query-string';
import MiniSpinner from "../common/MiniSpinner";
import FluConsentConfirmation from "./FluConsentConfirmation";
import StaticHtmlContent from "../common/staticHtmlContent";

class FluConsent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isAcceptTermsSelected: false,
            validationError: "",
            successMessage: "Your flu vaccination information will be submitted."
        };

        this.agreeAndSubmit = this.agreeAndSubmit.bind(this);
        this.acceptTermsSelected = this.acceptTermsSelected.bind(this);

        this.isMobile = false;
        if (typeof props.location !== 'undefined' && props.location) {
            const params = queryString.parse(props.location.search);
            if (params && params.mobile === 'true') {
                this.isMobile = true;
            }
        }
    }

    componentDidMount() {
        this.props.getConsentTypeList(this.props.token);
        logUI("MBHWeb.UI.FluConsent.ComponentDidMount", new Date(), Tools.getURLPath());
    }
    isValidate() {
        return this.state.isAcceptTermsSelected;
    }

    acceptTermsSelected(e) {
        if (e.target && e.target.checked)
            this.setState({ isAcceptTermsSelected: true, validationError: "" });
        else
            this.setState({ isAcceptTermsSelected: false });
    }

    agreeAndSubmit() {
        const { isFluInEpic, isFluInPeopleSoft, pshrNotAvailableMsg, psAvailableBeforeConsentMsg, mrAvailableBeforeConsentMsg } = this.props;
        if (this.isValidate()) {
            logUI("MBHWeb.UI.ConsentTerms", new Date(), Tools.getURLPath());
            let sMessage = (isFluInEpic === false && isFluInPeopleSoft === false) ? pshrNotAvailableMsg : (isFluInEpic === false ? psAvailableBeforeConsentMsg : mrAvailableBeforeConsentMsg);
            this.setState({ successMessage: sMessage });
            this.props.setFluConsent(this.props.token, true);
            this.setState({ isSubmitted: true });
        }
        else {
            const { isAcceptTermsSelected, validationError } = this.state;
            if (isAcceptTermsSelected && validationError !== "") {
                this.setState({ validationError: "" });
            }
            else if (validationError === "" || validationError === undefined) {
                this.setState({ isAcceptTermsSelected: false, validationError: "Please agree to the terms." });
            }
        }
    }

    render() {

        const { isSubmitted, validationError, successMessage } = this.state;
        const { primaryUser, currentUser, isLoggedIn,
            isEmployee, consentTypeList, fluSuccess, fluPending, proxyLoaded, 
            title, consentLabel, consentTypeFailure, isFluConsentCurrent, isFluStatusFailure } = this.props;
        const primaryid = primaryUser ? primaryUser.mi.toLowerCase() : null;
        const currentid = currentUser ? currentUser.mi.toLowerCase() : null;

        let fluVerbiage = "Consent to share flu vaccination information with Baylor Scott & White Health.";
        let fluConsentType = consentTypeList && consentTypeList.length > 0 ? consentTypeList.filter(t => t.stringKey === window.serverData.data.currentFluKey) : null;
        let fluVerbiageNote = "";

        if (fluConsentType && fluConsentType.length > 0) {
            fluVerbiage = fluConsentType[0].verbiage;
            fluVerbiageNote = fluConsentType[0].verbiage2;
        }
        let consentInfo = "It's easy to transfer your flu vaccine information from your electronic medical record (Epic) to PeoplePlace or from PeoplePlace to Epic.";
        let bswhConsentMsg = "If you received the flu vaccine from a Baylor Scott and White provider, you can choose to have that documentation transferred from your medical record in Epic to your employee health record in PeoplePlace.";
        let employeeHealthConsentMsg = "If you received the flu vaccine from Employee Health, you can choose to have that documentation transferred from PeoplePlace to your medical record in Epic."
        let afpMsg = "This provides Employee Health proof of your compliance with the Annual Flu Program.";

        return (
            <div className="container-fluid body-content flu-consent-container full-width">
               {
                    (currentid !== null && primaryid !== null && proxyLoaded)
                        ? isSubmitted && fluSuccess && !fluPending
                            ? <FluConsentConfirmation successMessage={successMessage} />
                            : isSubmitted && fluPending === false && !validationError
                                ? <FluConsentConfirmation failureMessage="We are currently unable to update your consent." />
                                : <div className="row">
                                    <div className="col-12 maxWidth-content">
                                        <React.Fragment>
                                            <div className="row">
                                                <div className="col-12">
                                                    <h1 className="page-heading">Flu Vaccination Consent</h1>
                                                </div>
                                            </div>
                                            {consentTypeFailure || isFluStatusFailure ?
                                                <SectionLoadingError message="Failed to load. Please try again later." /> :
                                                <>
                                                    {(fluConsentType && fluVerbiage && (isFluConsentCurrent !== null || isEmployee === false)) ? <>
                                                        {
                                                            currentid !== primaryid ?
                                                                <div className="row">
                                                                    <div className="col-12">
                                                                        <SectionLoadingError message="This type of consent can only be set by the account holder." sectionErrorClass="not-available-error" titleIcon="icon-log-out" />
                                                                    </div>
                                                                </div> :
                                                                <> {
                                                                    (isEmployee === false || isLoggedIn === false) ?
                                                                        <div className="row">
                                                                            <div className="col-12 maxWidth-content">
                                                                                <SectionLoadingError message="You have no medical consents available." sectionErrorClass="no-results-error" />
                                                                            </div>
                                                                        </div>
                                                                        : <> {isFluConsentCurrent === false ?
                                                                            <React.Fragment>
                                                                                <div className="row">
                                                                                    <div className="col-12">
                                                                                        {
                                                                                            fluPending === true && <Spinner />
                                                                                        }
                                                                                        <div className="row">
                                                                                            <div className="col-12">
                                                                                                <h2 className="form-section-heading">{title}</h2>
                                                                                            </div>
                                                                                            <div className="col-12">
                                                                                                <p>{consentInfo}</p>
                                                                                            </div>
                                                                                            <div className="col-12 consents-wrapper">
                                                                                                <ul className="angle-bullets">
                                                                                                    <li>{bswhConsentMsg}</li>
                                                                                                    <li>{employeeHealthConsentMsg}</li>
                                                                                                    <li>{afpMsg}</li>
                                                                                                </ul>
                                                                                            </div>
                                                                                            <div className="col-12 form-group">
                                                                                                <label className="checkbox-container">
                                                                                                    <input type="checkbox" onChange={this.acceptTermsSelected} />
                                                                                                    <span className="checkmark" />
                                                                                                    <span className="checkbox-label">{consentLabel}</span>
                                                                                                </label>
                                                                                            </div>
                                                                                            <div className="col-12 submit-consent-container">
                                                                                                {
                                                                                                    (validationError && validationError !== "") &&
                                                                                                    <div className="error-msg">
                                                                                                        {validationError}
                                                                                                    </div>
                                                                                                }
                                                                                                <input type="submit" className="btn btn-primary" value="AGREE AND SUBMIT" onClick={this.agreeAndSubmit} />
                                                                                            </div>
                                                                                            <div className="col-12 flu-consent-notes">
                                                                                                {fluVerbiageNote && <StaticHtmlContent content={fluVerbiageNote} />}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </React.Fragment> :
                                                                            <SectionLoadingError message="Consent has already been submitted." sectionErrorClass="no-results-error" />} </>
                                                                }</>
                                                        }
                                                    </> : <Spinner />
                                                    }
                                                </>
                                            }
                                        </React.Fragment>
                                    </div>
                                </div>
                        : <Spinner />
                }
            </div>

        );
    }
}

FluConsent.defaultProps = {
    title: "Transfer Flu Vaccination Data to Employee Health or Medical Record",
    consentLabel: "I have read and agree to the terms above",
    note: "Note: Employees who received flu vaccination outside of Employee Health at an off-site location (i.e. Walmart, CVS or other non-Baylor Scott & White Health facility), will need to provide documentation that a flu immunization was received after Aug. 1, 2020. Submit the required documentation (physician's note, receipt, etc.) to Employee Health at <a href='mailto:eHealth@BSWHealth.org'>eHealth@BSWHealth.org</a>.",
    pshrNotAvailableMsg: "Once your flu vaccination is available, it will be submitted to PeoplePlace which will fulfill your requirement and to your electronic medical record which will be available in Preventive Care.",
    psAvailableBeforeConsentMsg: "Your flu vaccination will be submitted to your electronic medical record and will be available in Preventive Care once your request is processed.",
    mrAvailableBeforeConsentMsg: "Your flu vaccination information will be submitted to PeoplePlace. This provides Employee Health proof of your compliance with the Annual Flu Program."
};

const mapStateToProps = (state, ownProps) => {
    return {
        isLoggedIn: state.domain.li,
        isEmployee: state.domain.ie,
        fluPending: state.profileTools.fluPending,
        fluSuccess: state.profileTools.fluSuccess,
        token: state.domain.t,
        currentUser: state.domain.cu,
        primaryUser: state.domain.pu,
        history: state.session.history,
        proxyLoaded: state.domain.pl !== null,
        consentTypeList: state.profileTools.consentTypeList,
        consentTypePending: state.profileTools.consentTypePending,
        consentTypeFailure: state.profileTools.consentTypeFailure,
        isFluStatusFailure: state.portal.fluStatusFailure,
        isFluInEpic: state.portal.fluStatusSummary ? state.portal.fluStatusSummary.immunizationFoundInEpic : false,
        isFluInPeopleSoft: state.portal.fluStatusSummary ? state.portal.fluStatusSummary.immunizationFoundInPeopleSoft : false,
        isFluConsentCurrent: state.portal.fluStatusSummary ? state.portal.fluStatusSummary.consentIsCurrent : null,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFluConsent: (token, value) => { dispatch({ type: types.CONSENT_SET_FLU, key: window.serverData.data.currentFluKey, approved: value, token: token }); },
        getConsentTypeList: (token) => { dispatch({ type: types.CONSENT_TYPE_LIST_GET, token: token }); }
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FluConsent));
